import script from "./CalculationList.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculationList.vue?vue&type=script&setup=true&lang=js"

import "./CalculationList.vue?vue&type=style&index=0&id=45b4a5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b4a5e2"]])

export default __exports__